export default "__VITE_ASSET__CDFOzPmv__"